module.exports = __webpack_public_path__ + "static/fonts/BMEuljirooraeorae.ttf?fd5e1689";